import { useEffect, useState } from "react";
import { SortedCatalog } from "../components/SortedCatalog";
import { gameDefinitions } from "./gameDefinitons";
import { GameCard } from "./GameCard";
import { fetchGamePopularity, type GamePopularity } from "./gamesApi";

export function GameCatalog({ limit }: { limit?: number }) {
  const [popularity, setPopularity] = useState<GamePopularity>({});

  useEffect(() => {
    const controller = new AbortController();
    fetchGamePopularity(controller.signal)
      .then((stats) => {
        if (!controller.signal.aborted) setPopularity(stats);
      })
      .catch(() => {
        // With no scores, popularity falls back to newest first.
      });
    return () => controller.abort();
  }, []);

  const popularityScores = Object.fromEntries(
    Object.entries(popularity).map(([name, game]) => [
      name,
      game.stats.visits.last30days
    ])
  );

  return (
    <SortedCatalog
      items={gameDefinitions}
      label="Sort games"
      defaultOrder="popular"
      popularityScores={popularityScores}
      limit={limit}
      renderItem={(item) => (
        <GameCard
          heading={limit ? "h3" : "h2"}
          key={item.name}
          game={item}
          to={`/games/${item.name}`}
        />
      )}
    />
  );
}
